import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faAddressBook,
  faFileInvoiceDollar,
  faLock,
  faTags,
} from "@fortawesome/free-solid-svg-icons";

function HeaderContactMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "white",
          paddingTop: "0.43rem",
          fontWeight: 350,
          textTransform: "none",
          fontSize: "1rem",
        }}
      >
        <span style={{ marginRight: "0.5rem" }}>
          <FontAwesomeIcon icon={faAddressBook} color="white" />
        </span>
        &nbsp;Contacts
        <span style={{ marginLeft: "0.5rem" }}>
          {open ? (
            <FontAwesomeIcon icon={faAngleUp} color="white" />
          ) : (
            <FontAwesomeIcon icon={faAngleDown} color="white" />
          )}
        </span>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link
            className="nav-link"
            to="/admin/contacts"
            style={{ color: "black" }}
          >
            <FontAwesomeIcon icon={faAddressBook} />
            &nbsp; Contacts
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            className="nav-link"
            to="/admin/tags_contacts"
            style={{ color: "black" }}
          >
            <FontAwesomeIcon icon={faTags} />
            &nbsp; Tags
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            className="nav-link"
            to="/admin/invoices"
            style={{ color: "black" }}
          >
            <FontAwesomeIcon icon={faFileInvoiceDollar} />
            &nbsp; Factures
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            className="nav-link"
            to="/admin/rgpd"
            style={{ color: "black" }}
          >
            <FontAwesomeIcon icon={faLock} />
            &nbsp; RGPD
          </Link>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default HeaderContactMenu;
